import { FunctionalComponent, h } from 'preact';
import { PaymentMode, PaymentState } from '../../../helpers/use-payments-helper';
import { i18nKeyValue } from '../../../i18n/strings/types';

interface Props {
    langStrings: i18nKeyValue;
    onClickUpiBannerClick: () => void;
}

export const UpiAutopayBanner: FunctionalComponent<Props> = (props: Props) => {
    const {
        langStrings,
        onClickUpiBannerClick,
    } = props;

    return (
        <div className="banner">
            <img src="/assets/images/upi-banner-bg.png" class="banner" alt="UPI" />

            <div className="banner-container"
                onClick={onClickUpiBannerClick}>

                <div className="banner-text">
                    {langStrings.upi_ap_homepage_trust_seal.replace('XXX', '15000+').toUpperCase()}
                </div>
                <div className="data-container">
                    <div className="title-text">
                        {langStrings.UPIAutopay_PSBanner_message1}
                    </div>

                    <div className="description-container">
                        <span className="middle-text">
                            {langStrings.UPIAutopay_loanjourney_setupmessage5} <img src="/assets/images/upi-black.svg" alt="UPI" /> {langStrings?.UPIAutopay_loanjourney_setupmessage6}!
                        </span>
                    </div>
                </div>
                <div className="cta-parent-container">
                    <div className="cta-container">
                        <span className="cta">
                            {langStrings?.upi_ap_banner_cta}
                        </span>
                    </div>
                </div>
                <div className="marquee-container">
                    <div className="marquee-content">
                        <span className="bottom-text">
                            {langStrings?.upi_ap_banner_ticker_1} &nbsp;&nbsp;•&nbsp;&nbsp; {langStrings?.upi_ap_banner_ticker_2} &nbsp;&nbsp;•&nbsp;&nbsp; {langStrings?.upi_ap_banner_ticker_3}
                        </span>
                    </div>
                </div>
            </div>

        </div >
    );
};
